import { render, staticRenderFns } from "./sanctionListupload.vue?vue&type=template&id=5b989af0&scoped=true"
import script from "./sanctionListupload.vue?vue&type=script&lang=js"
export * from "./sanctionListupload.vue?vue&type=script&lang=js"
import style0 from "./sanctionListupload.vue?vue&type=style&index=0&id=5b989af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b989af0",
  null
  
)

export default component.exports